import { useCallback, useRef, useState } from "react";
import { FiLock, FiUser } from "react-icons/fi";
import { Form } from "@unform/web";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Spin } from "antd";

import { useAuth } from "../../hooks/auth";
import getValidationErrors from "../../utils/getValidationErrors";
import Input from "../../components/input";
import InputCPF from "../../components/input/mask";
import Button from "../../components/button";
import ImgSSPDS from "../../assets/BRASÃO SSPDS NOVO.svg";

import { Container, Content, AnimationContainer } from "./styles";

function LoginWrapper() {
  const { signIn } = useAuth();
  const formRef = useRef(null);
  const [loading, setloading] = useState(false);

  const handleSubmit = useCallback(
    async ({ cpf, password }) => {
      try {
        setloading(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          cpf: Yup.string().required("CPF é obrigatório"),
          password: Yup.string().required("Senha obrigatória"),
        });

        await schema.validate(
          { cpf, password },
          {
            abortEarly: false,
          }
        );

        const patt1 = /[0-9]/g;
        cpf = cpf.toString();
        password = password.toString();
        cpf = cpf.match(patt1).join("");

        await signIn({ cpf, password });
      } catch (err) {
        if (err) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }
        toast.error("Ocorreu um erro ao fazer login, cheque as credenciais");
      } finally {
        setloading(false);
      }
    },
    [signIn]
  );

  return (
    <>
      <Container>
        <Content>
          <Spin spinning={loading}>
            <AnimationContainer>
              <Form ref={formRef} onSubmit={handleSubmit} className="form">
                <div className="row">
                  <div>
                    <h3>Bem-vindo ao</h3>
                    <h1>SSA</h1>
                  </div>
                </div>
                <img
                  src={ImgSSPDS}
                  alt="SSPDS"
                  style={{ height: 150, width: 120 }}
                />

                <h1>Login</h1>

                <InputCPF
                  className="input"
                  name="cpf"
                  mask="999.999.999-99"
                  icon={FiUser}
                  placeholder="CPF"
                />

                <Input
                  className="input"
                  name="password"
                  icon={FiLock}
                  type="password"
                  placeholder="Senha"
                />

                <br />

                <Button type="submit">Entrar</Button>
              </Form>
            </AnimationContainer>
          </Spin>
        </Content>
      </Container>
    </>
  );
}

export default LoginWrapper;
